/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThreadSummary
 */
export interface ThreadSummary {
    /**
     * 
     * @type {string}
     * @memberof ThreadSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSummary
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSummary
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSummary
     */
    deletedAt: string;
}

/**
 * Check if a given object implements the ThreadSummary interface.
 */
export function instanceOfThreadSummary(value: object): value is ThreadSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('deletedAt' in value) || value['deletedAt'] === undefined) return false;
    return true;
}

export function ThreadSummaryFromJSON(json: any): ThreadSummary {
    return ThreadSummaryFromJSONTyped(json, false);
}

export function ThreadSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThreadSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'createdAt': json['createdAt'],
        'deletedAt': json['deletedAt'],
    };
}

export function ThreadSummaryToJSON(json: any): ThreadSummary {
    return ThreadSummaryToJSONTyped(json, false);
}

export function ThreadSummaryToJSONTyped(value?: ThreadSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'createdAt': value['createdAt'],
        'deletedAt': value['deletedAt'],
    };
}

